module.exports = __webpack_public_path__ + "media/vipski.08476aeb.mp4";